import { Component, Inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PaymentResultUnknownDialogData {
  invoiceIds: number[];
  amount: number;
  primaryEmailRecipient: string;
  firmName: string;
}

@Component({
  selector: 'app-payment-result-unknown-dialog',
  templateUrl: './payment-unknown.component.html',
  styleUrls: ['./payment-unknown.component.scss'],
  standalone: false,
})
export class PaymentResultUnknownDialogComponent {
  mailTo: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PaymentResultUnknownDialogData,
    public dialogRef: MatDialogRef<PaymentResultUnknownDialogComponent>,
    private currencyPipe: CurrencyPipe,
  ) {
    this.mailTo = this.getMailTo();
  }

  getMailTo(): string {
    const subdomain = window.location.host;
    const invoiceIds = this.data.invoiceIds?.join('\n');

    const mailTo = 'mailto:support@aiwyn.ai?'
      + encodeURI(`subject=Unable to confirm payment for ${this.data.firmName}&body=`
        + `I received an error message while trying to make a payment to ${this.data.firmName}\n`
        + `URL: ${subdomain}\n`
        + `Payment amount: ${this.currencyPipe.transform(this.data.amount ?? 0)}\n`
        + (this.data.primaryEmailRecipient ? `Client username: ${this.data.primaryEmailRecipient}\n` : '')
        + (invoiceIds ? `Invoices:\n${invoiceIds}\n` : ''),
      );

    return mailTo;
  }

  openEmail(): void {
    this.dialogRef.close(true);
    window.open(this.mailTo);
  }
}
